import { Drawer } from "antd"
import MerchantApplicationWelcome from "./MerchantApplicationWelcome"
import { MerchantStatusData } from "../../../domain/invoicing/rainforest"
import MerchantApplicationForm from "./MerchantApplicationForm"

type Props = {
  isOpen: boolean
  onClose: () => void
  merchantData?: MerchantStatusData
  onApplicationSubmitted: () => void
}

const MerchantApplicationDrawer = ({ isOpen, onClose, merchantData, onApplicationSubmitted }: Props) => {
  const showWelcome = (merchantData?.merchantStatus ?? '') === ''

  return <Drawer
    open={isOpen}
    onClose={onClose}
    title="SynkedUP Payments Application"
    width={600}
  >
    {isOpen && showWelcome && <MerchantApplicationWelcome />}
    {isOpen && !showWelcome && merchantData !== undefined && <MerchantApplicationForm
      merchantStatusData={merchantData}
      onApplicationSubmitted={onApplicationSubmitted}
    />}
  </Drawer>
}

export default MerchantApplicationDrawer